import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  private baseurl = "";
  private apiroute = "";

  constructor(
    private http: HttpClient,
    private appSetting: AppConfigService,
  ) {
    this.baseurl = this.appSetting.apiBaseUrl;
    this.apiroute = '/FlexIntegration';
  }

  GetApplicationNotesAll() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ApplicationNotesAll' });
  }

  GetMasterApplicationNotesAll() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterApplicationNotesAll' });
  }

  Get_ApplicationCommSequence() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ApplicationCommSequence' });
  }

  Get_MasterApplicationCommSequence() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterApplicationCommSequence' });
  }

  GetPointType() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_PointType' });
  }

  GetPointTypeMaster() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_PointTypeMaster' });
  }

  GetWiringDiagram(){
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_WiringdiagramListCE' });
  }

  GetMasterPointType() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterPointType' });
  }

  Get_EstDrawingListTemplateCE() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstDrawingListTemplateCE' });
  }

  GetObjectTypes() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimateObjectType' });
  }

  GetMasterObjectTypes() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterEstimateObjectType' });
  }

  GetParts() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_AccPartsEngUtility' });
  }

  GetUnits() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_UnitsEngUtility' });
  }

  GetMasterUnits() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterUnitsEngUtility' });
  }

  GetTest() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_CommisionngProcEngUtility' });
  }

  GetMasterTest() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterCommisionngProcEngUtility' });
  }

  GetWiringdiagram() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'GetWiringdiagramCE' });
  }

  UpdateApplicationNotes(id, applicationnote, labelname, testids, pointtypeid, partid, wdid, unitid, objectreffid, enable) {
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'SaveUpdateAppNotesCE',
        id: id,
        applicationnote: applicationnote,
        labelname: labelname,
        testids: testids,
        pointtypeid: pointtypeid,
        partid: partid,
        wdid: wdid,
        unitid: unitid,
        objectreffid: objectreffid,
        enable: enable
      });
  }

  UpdateMasterApplicationNotes(id, applicationnote, labelname, testids, pointtypeid, partid, wdid, unitid, objectreffid, enable) {
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'SaveMasterUpdateAppNotesCE',
        id: id,
        applicationnote: applicationnote,
        labelname: labelname,
        testids: testids,
        pointtypeid: pointtypeid,
        partid: partid,
        wdid: wdid,
        unitid: unitid,
        objectreffid: objectreffid,
        enable: enable
      });
  }

  UpdateApplicationNotesMultiple(id, applicationnote, labelname, testids, pointtypeid, partid, wdid, unitid, objectreffid, enable, readingRange,minvalue, maxvalue) {
    const model =  {
      'method': 'SaveUpdateAppNotesCE',
      id: id == undefined ? 0:id,
      applicationnote: applicationnote,
      labelname: labelname,
      testids: testids,
      pointtypeid: pointtypeid,
      partid: partid,
      wdid: wdid,
      unitid: unitid,
      objectreffid: objectreffid,
      enable: enable,
      readrange:minvalue,
      // minvalue:minvalue,
      readrangemax:maxvalue
    }
    console.log(model)
    return this.http.post<any>(this.baseurl + this.apiroute, model
     );
  }

  UpdateMasterApplicationNotesMultiple(id, applicationnote, labelname, testids, pointtypeid, partid, wdid, unitid, objectreffid, enable, readingRange,minvalue, maxvalue) {
    const model =  {
      'method': 'SaveMasterUpdateAppNotesCE',
      id: id == undefined ? 0:id,
      applicationnote: applicationnote,
      labelname: labelname,
      testids: testids,
      pointtypeid: pointtypeid,
      partid: partid,
      wdid: wdid,
      unitid: unitid,
      objectreffid: objectreffid,
      enable: enable,
      readrange:minvalue,
      // minvalue:minvalue,
      readrangemax:maxvalue
    }
    console.log(model)
    return this.http.post<any>(this.baseurl + this.apiroute, model
     );
  }

  SaveUpdateEstimateObjectReference(id, reff, objectname, active) {

    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'Insert_SaveUpdateEstimateObjectReference',
        id: id,
        reff: reff,
        objectname: objectname,
        active: active
      });
  }

  SaveUpdateMasterEstimateObjectReference(id, reff, objectname, active) {

    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'Insert_SaveMasterUpdateEstimateObjectReference',
        id: id,
        reff: reff,
        objectname: objectname,
        active: active
      });
  }

  SaveUpdateEstimateProgramerAddObjects(id, typeid, unitid, tag, objectname, systemtypeid, active) {

    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'Insert_SaveUpdateEstimateProgramerAddObjects',
        id: id,
        typeid: typeid,
        unitid: unitid,
        tag: tag,
        objectname: objectname,
        systemtypeid: systemtypeid,
        active: active,
      });
  }

  SaveUpdateMasterEstimateProgramerAddObjects(id, typeid, unitid, tag, objectname, systemtypeid, active) {

    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'Insert_SaveMasterUpdateEstimateProgramerAddObjects',
        id: id,
        typeid: typeid,
        unitid: unitid,
        tag: tag,
        objectname: objectname,
        systemtypeid: systemtypeid,
        active: active,
      });
  }

  GetCommisionngProcEngUtility() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_CommisionngProcEngUtility' });
    // return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_CommisioningActions' });
  }

  GetMasterCommisionngProcEngUtility() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterCommisionngProcEngUtility' });
  }

  GetRegions() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_Regions' });
  }
  GetRegionsTree() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_CustomerDivision_ParentChild' });
  }
  GetEstimatetypicalsov() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_Estimatetypicalsov' });
  }
  GetTagEngUtility() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_TagEngUtility' });
  }
  GetTaskCatAssignedEngUtility(parentid = '0') {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_TaskCatAssignedEngUtility', parentid: parentid });
  }

  GetTaskCatAssignedEngUtilityCE(parentid = '0') {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_TaskCatAssignedEngUtilityCE', parentid: parentid });
  }

  GetTaskCatAssignedEngUtility2() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_TaskCategoryCE' });
  }

  InsetUpdate_Estimatetypicalsov(id,clientid,descriptionofwork,sort,inactive,projectodocatid,active,typicalpercentamnt) {
    let model = {
      'method': 'InsetUpdate_Estimatetypicalsov',
      id: id,
      clientid: clientid,
      descriptionofwork: descriptionofwork,
      sort: sort,
      inactive: inactive,
      projectodocatid: projectodocatid,
      active: active,
      typicalpercentamnt: typicalpercentamnt,
    }
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  GetTaskCatNotAssignedEngUtility() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_TaskCatNotAssignedEngUtility', pageindex: 1, pagesize: 10000 });
  }

  GetMasterTaskCatNotAssignedEngUtility() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterTaskCatNotAssignedEngUtility', pageindex: 1, pagesize: 10000 });
  }

  GetSystemEngUtility() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_SystemEngUtility' });
  }

  InsertUpdateSystemTypesEngUtility(Id, Typename, Availabe, vav, shop, parentId, image) {
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'InsertUpdate_SystemTypesEngUtility',
        typrname: Typename,
        available: Availabe,
        vav: vav,
        shop: shop,
        parentid: parentId,
        image: image,
        id: Id,
      });
  }

  UpdateInsertCustomerDivision(id, name, active) {
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'Update_Insert_CustomerDivision',
        DivisionName: name,
        RegionID: id,
        Active: active ? 1 : 0
      });
  }

  GetCommisioningTag() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_CommisioningTag' });
  }

  GetMasterCommisioningTag() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterCommisioningTag' });
  }

  GetCommisioningActions() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_CommisioningActions' });
  }

  GetMasterCommisioningActions() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_MasterCommisioningActions' });
  }

  InsertUpadte_CommisionngSequenceUtility(id,functionname,testobjective,action,reaction,actiontag,actioncmd,reactiontag,reactionendvalueid,actionvalue) {
    let model = {
      'method': 'InsertUpadte_CommisionngSequenceUtility',
      id: id,
      functionname: functionname,
      testobjective: testobjective,
      action: action,
      reaction: reaction,
      actiontag: actiontag,
      actioncmd: actioncmd,
      reactiontag: reactiontag,
      reactionendvalueid: reactionendvalueid,
      actionvalue: actionvalue,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute,
      model);
  }

  InsertUpadte_CommisionngSequenceUtilityEditMultiple(id,functionname,testobjective,action,reaction,actiontag,actioncmd,reactiontag,reactionendvalueid,actionvalue,
    ACTIONTIME) {
    let model = {
      'method': 'InsertUpadte_CommisionngSequenceUtility',
      id: id,
      functionname: functionname,
      testobjective: testobjective,
      action: action,
      reaction: reaction,
      actiontag: actiontag,
      actioncmd: actioncmd,
      reactiontag: reactiontag,
      reactionendvalueid: reactionendvalueid,
      actionvalue: actionvalue,
      actiontime:ACTIONTIME
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute,
      model);
  }

  InsertUpadte_CommisionngSequenceUtilityNew(id,functionname,testobjective,action,reaction,actiontag,actioncmd,reactiontag,reactionendvalueid,actionvalue, Detail_Id, READINGRANGE, ACTIONTIME) {
    let model = {
      'method': 'InsertUpadte_CommisionngSequenceUtility',
      id: id,
      functionname: functionname,
      testobjective: testobjective,
      action: action,
      reaction: reaction,
      actiontag: actiontag,
      actioncmd: actioncmd,
      reactiontag: reactiontag,
      reactionendvalueid: reactionendvalueid,
      actionvalue: actionvalue,
      systemdetailid:Detail_Id,
      READINGRANGE:READINGRANGE,
      actiontime:ACTIONTIME,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute,
      model);
  }



  InsertUpadteCommisionngProcEngUtility(id, functionname, testobjective, action, reaction, actiontag, actioncmd, reactiontag, reactionendvalueid, actionvalue) {
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'InsertUpadte_CommisionngProcEngUtility',
        id: id,
        functionname: functionname,
        testobjective: testobjective,
        action: action,
        reaction: reaction,
        actiontag: actiontag,
        actioncmd: actioncmd,
        reactiontag: reactiontag,
        reactionendvalueid: reactionendvalueid,
        actionvalue: actionvalue,
      });
  }

  InsertUpadteCommisionngProcEngUtilityJSON(data) {
    return this.http.post<any>(this.baseurl + this.apiroute, data);
  }

  InsertUpdateSystemTagsEngUtility(id, sort, tag, typename, parentid, active, descriptions) {
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'InsertUpdate_SystemTagsEngUtility',
        id: id,
        sort: sort,
        tag: tag,
        typename: typename,
        parentid: parentid,
        active: active,
        descriptions: descriptions,
      });
  }

  GetCustomerDivisionParts(id) {
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'Get_CustomerDivisionParts_List',
        DivisionID: id,
      });
  }

  GetCustomerDivisionsPartsList(name) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimatePartsLabor-CE', partnamefilter: name });
    // return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimateParts', partnamefilter: name });
  }

  GetGateways() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'GetGateways' });
    // return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimateParts', partnamefilter: name });
  }

  InsertGateway(ID: string, gatewayID: string, active: number) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'InsertUpdateGateways', 'id': ID, 'gatewayid': gatewayID, 'active': active });
  }

  SaveUpdateLaborPart(PartID, RegionID, PartCost, PartCostID, Partefficiency) {
    let model = {
      'method': 'Update_Insert_CustomerDivisionParts ',
      PartID: PartID,
      RegionID: RegionID,
      PartCost: PartCost,
      PartCostID: PartCostID,
      Partefficiency: Partefficiency,
    }

    // console.log(JSON.stringify(model));
    console.log(model)
    return this.http.post<any>(this.baseurl + this.apiroute, model
    );
  }

  DeleteTaskCatAssignedEngUtility(id) {
    // id = id < 0 ? id * -1 : id;
    return this.http.post<any>(this.baseurl + this.apiroute,
      {
        'method': 'DeleteMultiple_TaskCatAssignedEngUtility',
        id: id,
        catid: 0,
        partid: 0
      });
  }

  InsertTaskCatAssignedEngUtility(partid, catid) {
    // id = id < 0 ? id * -1 : id;
    let model = {
      'method': 'Insert_TaskCatAssignedEngUtility',
      partid: partid,
      catid: catid
    }

    console.log(JSON.stringify(model))
    return this.http.post<any>(this.baseurl + this.apiroute, model
    );
  }

}
